export type SearchMatchSegment = {
  text: string;
  highlight: boolean;
};

export function getSearchMatchSegments(
  text: string,
  query: string
): SearchMatchSegment[] {
  const trimmedQuery = query.trim();

  if (!trimmedQuery || !text) {
    return [{ text, highlight: false }];
  }

  const segments: SearchMatchSegment[] = [];
  const lowerText = text.toLowerCase();
  const lowerQuery = trimmedQuery.toLowerCase();
  let startIndex = 0;

  while (startIndex < text.length) {
    const matchIndex = lowerText.indexOf(lowerQuery, startIndex);

    if (matchIndex === -1) {
      segments.push({ text: text.slice(startIndex), highlight: false });
      break;
    }

    if (matchIndex > startIndex) {
      segments.push({
        text: text.slice(startIndex, matchIndex),
        highlight: false,
      });
    }

    segments.push({
      text: text.slice(matchIndex, matchIndex + trimmedQuery.length),
      highlight: true,
    });

    startIndex = matchIndex + trimmedQuery.length;
  }

  return segments.length > 0 ? segments : [{ text, highlight: false }];
}
